import insightsClient from 'search-insights';

export function handleAlgoliaParameters(itemNo: string): void {
    const params = new URLSearchParams(window.location.search);
    const queryId = params.get('q'); // queryId
    const position = params.get('p'); // position
    if (!queryId && !position) {
        return; // Exit early if no relevant parameters
    }

    try {
        // Remove parameters and update URL only if necessary
        params.delete('q');
        params.delete('p');
        const newUrl =
            window.location.pathname + (params.toString() ? `?${params.toString()}` : '') + window.location.hash;

        if (window.location.href !== newUrl) {
            window.history.replaceState({}, '', newUrl);
        }
        // Send analytics event only if both parameters exist
        if (queryId && position) {
            insightsClient('clickedObjectIDsAfterSearch', {
                eventName: 'Items clicked',
                index: 'products',
                objectIDs: [itemNo],
                positions: [Number(position)],
                queryID: queryId,
            });
        }
    } catch (error) {
        console.error('Error handling Algolia parameters:', error);
    }
}
